// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "chessflix-17194.firebaseapp.com",
  "projectId": "chessflix-17194",
  "storageBucket": "chessflix-17194.appspot.com",
  "messagingSenderId": "243688685082",
  "appId": "1:243688685082:web:7fefd18dcbaa192d62dba3",
  "measurementId": "G-SWFXQTPRKY",
  "apiKey": "AIzaSyBq_uYDVmF8wZM7uN0jlcNL3cu1eCDo5aE"
};
